module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"fieldLabelCategories":"Catégories","fieldLabelMainCategory":"Catégorie principale. le lieu affichera l\u0027icône de cette catégorie sur la carte","fieldLabelTags":"Tags"},"en":{"fieldLabelCategories":"Categories","fieldLabelMainCategory":"Main Category. The POI will display this category\u0027s icon on the map","fieldLabelTags":"Tags"}}')
  delete Component.options._Ctor
}
